import Marionette from "../../../shared/marionette-mustache";
import {GenericTabView} from "./generic-tab";
import {FulltextStatuteOutlineView} from "../fulltext-statute-outline";

export class LegislationOutlineView extends GenericTabView {

    private fulltextOutlineRegion: Marionette.Region;

    public regions(): any {
        const regions: any = {
            fulltextOutlineRegion: ".fulltext-statute-outline-region",
        };
        return regions;
    }

    public onShow() {
        const outlineView = new FulltextStatuteOutlineView({model: this.model.Data});
        this.fulltextOutlineRegion.show(outlineView);
    }

    public loadDocumentPdf() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/legislation-outline.ts